<div
  [routerLink]="['/curriculum']"
  [queryParams]="{ selected: level()?.slug }"
  class="bg-primary-50 capitalize hover:bg-primary text-primary hover:duration-300 hover:text-white rounded-xl cursor-pointer py-2">
  <p class="font-bold">{{ level()?.title }}</p>
</div>
